var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMisTramitesMenu(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 8.33317C2.5 5.19067 2.5 3.619 3.47667 2.64317C4.45333 1.66734 6.02417 1.6665 9.16667 1.6665H10.8333C13.9758 1.6665 15.5475 1.6665 16.5233 2.64317C17.4992 3.61984 17.5 5.19067 17.5 8.33317V11.6665C17.5 14.809 17.5 16.3807 16.5233 17.3565C15.5467 18.3323 13.9758 18.3332 10.8333 18.3332H9.16667C6.02417 18.3332 4.4525 18.3332 3.47667 17.3565C2.50083 16.3798 2.5 14.809 2.5 11.6665V8.33317Z",
    stroke: "#033261",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0001 5V6.66667M10.0001 6.66667V8.33333M10.0001 6.66667H8.33341M10.0001 6.66667H11.6667M6.66675 11.6667H13.3334M7.50008 15H12.5001",
    stroke: "#033261",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMisTramitesMenu);
export default __webpack_public_path__ + "static/media/MisTramitesMenu.37382e7d28ef0f4e2a1071b42e3e25c1.svg";
export { ForwardRef as ReactComponent };